import React from "react";

const Card = React.forwardRef(({ className = "", ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={[
        "rounded-2xl border border-slate-200/80 bg-white text-slate-900 shadow-sm",
        className,
      ].join(" ")}
      {...props}
    />
  );
});

Card.displayName = "Card";

const CardContent = React.forwardRef(({ className = "", ...props }, ref) => {
  return <div ref={ref} className={["p-0", className].join(" ")} {...props} />;
});

CardContent.displayName = "CardContent";

export { Card, CardContent };
